namespace('IO.Views.Components.Rje', function (exports) {
  var Codes = {
    PUPPET_DISABLED: 0,
    PUPPET_ENABLED_STOPPED: 1,
    PUPPET_ENABLED_RUNNING: 2,

    STATE_UNKNOWN: 0,
    STATE_RUNNING: 1,
    STATE_BLOCKED: 2,
    STATE_PAUSED: 3,
    STATE_SHUTTING_DOWN: 4,
    STATE_STOPPED: 5,
    STATE_CRASHED: 6,
  };

  exports.Codes = Codes;
});
